export default __webpack_public_path__ + "static/dank-mono-italic-108a69226f33e829c7b98e41215bd456.woff2";